import React from 'react';
import { NavLink } from 'react-router-dom';
import Icon from '../Icon';
import { signOut } from '../../Actions/Login.action';
import { translate } from '../../Services/translation';
import { useTypedSelector } from '../../Hooks/useTypedSelector';

const MyPagesDesktopMenu = ({ navigation }) => {
  const { current: userInfo } = useTypedSelector(
    (state) => state.userInfo
  );

  return (
    <div className="hidden lg:block">
      <div className="mb-3 flex flex-col capitalize">
        <span className="color-gray-600 text-md">
          {userInfo?.currentOrganizationName ??
            translate('mypage.site.title')}
        </span>
        <h5 className="name">
          {userInfo?.firstName} {userInfo?.lastName}
        </h5>
      </div>
      <ul className="overflow-hidden rounded border border-solid border-gray-300">
        {navigation.map(
          (option) =>
            option.active && (
              <li
                className="flex border-b border-solid border-gray-300 [&_.active]:bg-gray-100 [&_.active]:font-bold"
                key={option.url + 'desktop'}
              >
                <NavLink
                  className="flex-1 px-3 py-2 text-md hover:bg-gray-100 [&_:last-child]:border-b-0"
                  to={option.url}
                  end={option.url == '/'}
                >
                  {option.name}
                </NavLink>
              </li>
            )
        )}
        <li className="flex flex-1 cursor-pointer items-center p-2 px-3 text-md hover:bg-gray-100">
          <button onClick={signOut}>
            <Icon name="logout" className="mr-2 h-5 w-5 text-error-500" />
            {translate('general.sign-out')}
          </button>
        </li>
      </ul>
    </div>
  );
};

export default MyPagesDesktopMenu;
